// Currency service for handling currency conversions
// Exchange rates are now handled by backend API

export const currencyService = {

  // Detect user country
  async detectUserCountry() {
    try {
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
      
      if (data.country_code) {
        return data.country_code;
      }
      throw new Error('Could not detect country');
    } catch (error) {
      console.error('Error detecting country:', error);
      // Default to India
      return 'IN';
    }
  },

  // Convert INR to user currency
  convertINRToUserCurrency(inrAmount, userCountry, exchangeRate) {
    console.log('Converting price:', { inrAmount, userCountry, exchangeRate });
    
    if (userCountry === 'IN') {
      return {
        amount: inrAmount,
        currency: 'INR',
        symbol: '₹'
      };
    } else {
      // For US users: INR * 3, then convert to USD
      const usdPrice = (inrAmount * 3) / exchangeRate;
      console.log('USD calculation:', `${inrAmount} * 3 / ${exchangeRate} = ${usdPrice}`);
      return {
        amount: usdPrice,
        currency: 'USD',
        symbol: '$'
      };
    }
  },

  // Prepare order data - send only original INR prices, backend will handle calculations
  prepareOrderData(orderData, userCountry, exchangeRate) {
    console.log('Preparing order data:', { orderData, userCountry, exchangeRate });
    
    // Send only basic order info, backend will handle all currency calculations
    return {
      ...orderData,
      // Remove all currency calculations - backend will handle
      // Only send user country and exchange rate for backend reference
      metadata: {
        userCountry,
        exchangeRate
      }
    };
  }
};
